<div class="model" id="div_model_1ca02a91">
  <div class="background-img-section" id="div_background-img-section_1ea0b32f">
    <img
      aria-label="TRM rail car"
      title="TRM rail car"
      class="background-img"
      src="../../../assets/img/TILX-54518.webp"
      id="img_background-img_064b8f68"
    />
    <i class="pi pi-times" (click)="closeModel()" id="i_pi_9513ed49"></i>
  </div>

  <div class="detail-header" id="div_detail-header_80670a4f">
    <div class="title-wrapper" id="div_title-wrapper_0c352348">
      <div class="title-txt" id="div_title-txt_ce9fd920">
        {{ carDetails.model_desc }}
      </div>
    </div>
    <div class="header-wrapper" id="div_header-wrapper_ccc54684">
      <img
        aria-label="TRM image"
        title="TRM image"
        alt="TRM image"
        class="car-img"
        [src]="_imageURL_"
        onerror="this.src='../../../assets/images/image-not-found.webp'"
        id="img_car-img_2a58304e"
      />
      <div class="header-name" id="div_header-name_d32e8d8b">
        <div class="header-title" id="div_header-title_8dc41021">Quantity</div>
        <div
          class="header-value"
          [ngSwitch]="true"
          id="div_header-value_527a8d14"
        >
          <ng-container
            *ngSwitchCase="carDetails.count < 5"
            id="ng-container_c9166dfe"
            >Limited</ng-container
          >
          <ng-container
            *ngSwitchCase="carDetails.count > 25"
            id="ng-container_3ecb886f"
            >25+</ng-container
          >
          <ng-container *ngSwitchDefault id="ng-container_b2ef8e73">{{
            carDetails.count
          }}</ng-container>
        </div>
      </div>

      <div class="header-name" id="div_header-name_21268216">
        <div class="header-title" id="div_header-title_446a933c">Location</div>
        <div class="header-value" id="div_header-value_5bc4c771">
          {{ carDetails.display_location || carDetails.state }}
        </div>
      </div>

      <div class="header-name" id="div_header-name_b6432dbd">
        <div class="header-title" id="div_header-title_a1af6e10">
          car/mo (As-is)
        </div>
        <div class="header-value" id="div_header-value_acacd37a">
          ${{ carDetails.rate | number: '1.0-2' }}–{{
            carDetails.rate2 | number: '1.0-2'
          }}
        </div>
      </div>
    </div>
  </div>

  <div class="specs-section" id="div_specs-section_65e133f5">
    <div class="specs-container" id="div_specs-container_b5b61828">
      <div class="specs-label" id="div_specs-label_612832a6">Attributes</div>
      <ng-container
        *ngFor="let attr of displayedAttr"
        id="ng-container_3e2ab0ed"
      >
        <div
          class="detail"
          *ngIf="checkConditionalDisplayAttr(attr)"
          id="div_detail_1abe9326"
        >
          <span class="label" id="span_label_b2b9fcdb"
            >{{ attr.title }} <i id="i_bf256c8a">{{ attr.labelTail }}</i></span
          >

          <span
            *ngIf="isNan(carDetails[attr.field]); else number"
            class="var"
            id="span_var_a5e75ef6"
            >{{ carDetails[attr.field] }}</span
          >
          <ng-template #number="" id="ng-template_540413c6">
            <span class="var" id="span_var_e24f7b04">{{
              carDetails[attr.field] | number: '1.0' : 'en-US'
            }}</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="graph-section" id="div_graph-section_ba057fc4">
    <div class="graph-container" id="div_graph-container_66995e8d">
      <div class="graph-label" id="div_graph-label_af1be3b8">Railcar Age</div>
      <div class="black-square" id="div_black-square_b96abbdb">
        <div class="left-label" id="div_left-label_4f06d6ee"># of Railcars</div>
        <p-chart
          type="bar"
          [data]="railCarAgeData"
          [options]="chartOptions"
          width="406.93px"
          height="303.64px"
          [responsive]="true"
          id="p-chart_b2f81624"
        ></p-chart>
      </div>
      <div class="left-bottom" id="div_left-bottom_cbc0cb01">Years</div>
    </div>
    <div
      class="graph-container"
      *ngIf="displayComplianceDue"
      id="div_graph-container_845b936e"
    >
      <div class="graph-label" id="div_graph-label_f7b04d11">
        Compliance Due
        <img
          aria-label="TRM image"
          title="TRM image"
          alt="TRM image"
          class="tooltip-icon"
          src="../../../assets/icons/tooltip-icon.svg"
          pTooltip="
            <div>
              <div class='tooltip-header'>about compliance due</div>
              <div class='tooltip-body'>Compliance date reflects next stenciled tank car qualification due date, excluding lining.</div>
            </div>"
          [escape]="false"
          [tooltipStyleClass]="'compliance-due-tooltip'"
          tooltipPosition="bottom"
          id="img_tooltip-icon_c90b5f77"
        />
      </div>
      <div class="black-square" id="div_black-square_adae8f32">
        <div class="left-label" id="div_left-label_4113f506"># of Railcars</div>
        <p-chart
          type="bar"
          [data]="complianceDueData"
          [options]="chartOptions"
          width="406.93px"
          height="303.64px"
          [responsive]="true"
          id="p-chart_a8074b5e"
        ></p-chart>
      </div>
      <div class="left-bottom" id="div_left-bottom_d5b9a5cf">Year</div>
    </div>
  </div>

  <div class="footer-section" id="div_footer-section_0bb36f9b">
    <img
      alt="TRM image"
      aria-label="white logo"
      title="white logo"
      class="footer-logo"
      src="../../../assets/img/logo-white.svg"
      id="img_footer-logo_59805bcf"
    />
  </div>
</div>
